import axios from '../axios';
import auth from '@/auth/authService'

class ApiRequest {
  // constructor(config) {
  //   this.config = config;
  //   this.apiUrl = `${config.scheme}://${config.url}/${config.api_version}`;
  // }

  /**
   * 
   * @param {string} apiPath 
   * @param {object} params 
   * @param {object} headers 
   * @param {object} options 
   * @param {boolean} options.returnParam
   * @param {boolean} options.skipCache
   * @param {boolean} options.bypassCache
   * @param {callable} options.resCallback 
   * @returns {Promise<any>}
   */
  doGetRequest(apiPath, params = {}, headers = {}, {
    returnParam = false,
    skipCache = false,
    bypassCache = false,
    resCallback = null
  } = {}) {
    return new Promise((resolve, reject) => {

      if (!Object.prototype.hasOwnProperty.call(headers, 'Content-Type')) {
        headers['Content-Type'] = 'application/x-www-form-urlencoded';
      }

      if (skipCache) {
        params['timestamp'] = new Date().valueOf();
      }

      if (bypassCache) {
        params['admin_cache_bypass'] = new Date().valueOf();
      }

      axios.get(apiPath, {
        params,
        headers,
      }).then(res => {
        res = res.data;
        if (returnParam) {
          res = res[returnParam]
        }
        if (typeof resCallback === "function") {
          res = resCallback(res);
        }

        resolve(res);
      }).catch(function (error) {
        if (error.response?.data?.error === 'Invalid JWT') {
          auth.logOut();
        } else {
          reject(error);
        }
      });
    });
  }

  doPutRequest(apiPath, params = {}, headers = {}, {returnParam = false, skipJWT = false} = {}) {
    return new Promise((resolve, reject) => {

      if (!Object.prototype.hasOwnProperty.call(headers, 'Content-Type')) {
        headers['Content-Type'] = 'application/x-www-form-urlencoded';
      }
      if (!Object.prototype.hasOwnProperty.call(headers, 'X-Harness-JWT') && skipJWT === false) {
        headers['X-Harness-JWT'] = auth.getToken();
      }

      axios.put(apiPath,
        params,
        {
          headers,
        },
      ).then(res => {
        if (returnParam) {
          resolve(res.data[returnParam]);
        } else {
          resolve(res.data);
        }
      }).catch(function (error) {
        if (error.response?.data?.error === 'Invalid JWT') {
          auth.logOut();
        } else {
          reject(error);
        }
      });
    });
  }

  doPatchRequest(apiPath, params = {}, headers = {},
                 {returnParam = false, skipJWT = false} = {}
  ) {
    return new Promise((resolve, reject) => {

      if (!Object.prototype.hasOwnProperty.call(headers, 'Content-Type')) {
        headers['Content-Type'] = 'application/x-www-form-urlencoded';
      }
      if (!Object.prototype.hasOwnProperty.call(headers, 'X-Harness-JWT') && skipJWT === false) {
        headers['X-Harness-JWT'] = auth.getToken();
      }

      axios.patch(apiPath,
        params,
        {
          headers,
        },
      ).then(res => {
        if (returnParam) {
          resolve(res.data[returnParam]);
        } else {
          resolve(res.data);
        }
      }).catch(function (error) {
        if (error.response?.data?.error === 'Invalid JWT') {
          auth.logOut();
        } else {
          reject(error);
        }
      });
    });
  }

  doPostRequest(apiPath, params = {}, headers = {}, {returnParam = false, skipJWT = false} = {}) {
    return new Promise((resolve, reject) => {

      if (!Object.prototype.hasOwnProperty.call(headers, 'Content-Type')) {
        headers['Content-Type'] = 'application/x-www-form-urlencoded';
      }
      if (!Object.prototype.hasOwnProperty.call(headers, 'X-Harness-JWT') && skipJWT === false) {
        headers['X-Harness-JWT'] = auth.getToken();
      }

      axios.post(apiPath,
        params,
        {
          headers,
        },
      ).then(res => {
        if (returnParam) {
          resolve(res.data[returnParam]);
        } else {
          resolve(res.data);
        }
      }).catch(function (error) {
        if (error.response?.data) {
          if (skipJWT === false && error.response?.data?.error === 'Invalid JWT') {
            auth.logOut();
          } else {
            reject(error.response.data);
          }
        } else {
          reject(error);
        }
      });
    });
  }


  doDeleteRequest(apiPath, headers = {}, {returnParam = false} = {}) {
    return new Promise((resolve, reject) => {

      if (!Object.prototype.hasOwnProperty.call(headers, 'Content-Type')) {
        headers['Content-Type'] = 'application/x-www-form-urlencoded';
      }
      if (!Object.prototype.hasOwnProperty.call(headers, 'X-Harness-JWT')) {
        headers['X-Harness-JWT'] = auth.getToken();
      }

      axios.delete(apiPath,
        {
          headers,
        },
      ).then(res => {
        if (returnParam) {
          resolve(res.data[returnParam]);
        } else {
          resolve(res.data);
        }
      }).catch(function (error) {
        if (error.response?.data?.error === 'Invalid JWT') {
          auth.logOut();
        } else {
          reject(error);
        }
      });
    });
  }
}

export default new ApiRequest()
